import { Box, BoxProps } from '@air/zephyr';

export interface ItalicProps extends BoxProps<'i'> {}

export const Italic = ({ tx, ...restOfProps }: ItalicProps) => {
  return (
    <Box
      as="i"
      {...restOfProps}
      tx={{
        color: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontStyle: 'italic',
        ...tx,
      }}
    />
  );
};
